export default __webpack_public_path__ + "static/media/rules-icon.adec781b.svg";